/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import { BQLink } from '../../atoms/bqlink';
import { connect, useSelector } from 'react-redux';
import get from 'lodash/get';
import AdWithPlaceholder from '../../molecules/ad-with-placeholder';
import { isMobile } from 'react-device-detect';
import Icon from '@mdi/react';
import { mdiChevronRight, mdiChevronLeft } from '@mdi/js';
import { contentClick } from '../../../helpers/datalayer-utils';
import { makeApiCall } from '../../../helpers/utils';
import './state-of-the-economy.m.css';

const StateOfTheEconomy = ({ collection, imageCDN, widget, target, slideCount, sketchesHost }) => {
  const [ImageIdx, setImageIdx] = useState(0);
  const slider = useRef(null);
  const [items, setItems] = useState(get(collection, ['items', '0', 'story', 'cards'], []));
  const Summary = get(collection, ['summary'], '');
  const Header = get(collection, ['metadata', 'display-name'], get(collection, ['name'], ''));
  const story = get(collection, ['items', '0', 'story'], []);
  const slug = get(collection, ['items', '0', 'story', 'slug'], '');

  const settings = {
    centerMode: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    dotsClass: 'slick-StateCustom',
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    arrows: false,
    beforeChange: (current, next) => setImageIdx(next),
    responsive: [
      {
        breakpoint: 480,
        settings: {
          pauseOnHover: true,
          slidesToShow: 1,
          swipeToSlide: true,
        },
      },
    ],
  };
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  const sliderCode = () => {
    return (
      <div styleName={`StateOfEconomy-slider slider-dots-increase`}>
        <Slider {...settings} ref={slider}>
          {items.slice(0, slideCount).map((item, idx) => {
            const title = item?.['story-elements']?.filter(
              (element) => element?.type === 'title',
            )[0]?.text;
            const imageSlug = item?.['story-elements']?.filter(
              (element) => element?.type === 'image',
            )?.[0]?.['image-s3-key'];
            return (
              <div
                styleName={`image-slide ${idx === ImageIdx ? 'active-slide' : ''}`}
                onClick={() => contentClick(userData, story, pageType)}
                key={idx}
              >
                <img src={`https://${imageCDN}/${imageSlug}`} alt="State Of The Economy" />
                <span>{title}</span>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  };

  const sliderDiv = () => {
    if (!widget) {
      return (
        <BQLink href={`${slug}?src=budget`} target={widget ? target : ''}>
          {sliderCode()}
        </BQLink>
      );
    } else {
      return <React.Fragment>{sliderCode()}</React.Fragment>;
    }
  };

  useEffect(() => {
    if (items?.length === 0) {
      makeApiCall(`${sketchesHost}/api/v1/collections/${collection?.slug}`).then((res) => {
        setItems(get(res, ['items', '0', 'story', 'cards'], []));
      });
    }
  }, []);

  return items?.length > 0 ? (
    <div styleName="positioning">
      <>
        {isMobile && !widget && (
          <div className="responsive-ad content-center adWithPad mobile-only">
            <AdWithPlaceholder
              adtype="AdAboveStateOfEconomy"
              height="250px"
              width="336px"
              adUnit="Mid_300x250_4"
              sizes={[
                [300, 250],
                [336, 280],
              ]}
            />
          </div>
        )}
      </>
      <div styleName={`StateOfEconomy ${widget ? 'StateOfEconomy-widget' : ''}`}>
        <div styleName="StateOfEconomy-container">
          <BQLink
            href={widget ? `${slug}?src=budget` : slug}
            target={widget ? target : ''}
            styleName={widget ? 'disable-click' : ''}
          >
            <div styleName="StateOfEconomy-header">
              <img
                src="https://thumbor-stg.assettype.com/bqprimehindi/2023-01/4722296b-70ae-4806-b276-9c4340d05f0e/image_removebg_preview__3_.png"
                width="250px"
                alt="State Of The Economy"
              />
              <span>{Header}</span>
              <span>{Summary}</span>
            </div>
          </BQLink>
          {sliderDiv()}
          <div styleName="nextPrev-wrapper">
            <div
              styleName={`prev ${ImageIdx === 0 ? 'disabled' : ''}`}
              onClick={() => (ImageIdx === 0 ? '' : slider?.current?.slickPrev())}
            >
              <Icon path={mdiChevronLeft} size={'30px'} />
            </div>
            <div
              styleName={`next ${ImageIdx >= Math.min(items.length, slideCount) - 1 ? 'disabled' : ''}`}
              onClick={() =>
                ImageIdx >= Math.min(items.length, slideCount) - 1
                  ? ''
                  : slider?.current?.slickNext()
              }
            >
              <Icon path={mdiChevronRight} size={'30px'} />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

const mapStatetoProps = (state) => ({
  imageCDN: state.qt.config['cdn-image'],
  slideCount: get(state, ['qt', 'config', 'features', 'budget', 'state_of_economy_slide_count'], 6),
  sketchesHost: get(state.qt, ['config', 'sketches-host'], ''),
});

export default connect(mapStatetoProps)(StateOfTheEconomy);
